import React from "react";
import Label from "src/components/atoms/labels/label";

interface StatisticsCardProps {
	value: string;
	title: string;
	isLoading: boolean;
}

const StatisticsCard: React.FC<StatisticsCardProps> = ({
	value,
	title,
	isLoading = false,
}) => {
	return (
		<div className="flex flex-col w-[300px] h-[230px] shadow-xl overflow-hidden drop-shadow-xl">
			{/* Top Section */}
			<div className="flex flex-col items-center justify-center h-[70%] bg-[#2F8ECC]">
				{isLoading ? (
					<div className="animate-spin w-10 h-10 border-4 border-white border-t-transparent rounded-full"></div>
				) : (
					<span className="font-code font-semibold tracking-wider text-white text-8xl">
						{value}
					</span>
				)}
			</div>

			{/* Bottom Section */}
			<div className="flex items-center justify-center h-[30%] bg-[#003060]">
				<Label
					color="text-white"
					variant="subheader"
					text={title}
					className="uppercase"
				></Label>
			</div>
		</div>
	);
};

export default StatisticsCard;
